import { useState } from "react";
import EditableLabel from "../reusable-elements/editable-label";
import './keycode.css';

export const KeyCodeUI = ({ keyCode, onChange, onChangeName, canMoveDown, canMoveUp, moveDown, moveUp }) => {

    const [editOn, setEditOn] = useState(false);
    const [nameValue, setNameValue] = useState(keyCode.name);
    const [codeValue, setCodeValue] = useState(keyCode.value);

    return (
        <div className="keycode-card">
            <div className="keycode-content">
                <div className="keycode-controls">
                    {canMoveUp && (
                        <button 
                            className="btn btn-xs btn-icon btn-circle btn-default up-down-arrow" 
                            onClick={() => moveUp(keyCode)}
                            title="Move Up"
                        >
                            <i className="fa fa-arrow-up"></i>
                        </button>
                    )}
                    {canMoveDown && (
                        <button 
                            className="btn btn-xs btn-icon btn-circle btn-default up-down-arrow" 
                            onClick={() => moveDown(keyCode)}
                            title="Move Down"
                        >
                            <i className="fa fa-arrow-down"></i>
                        </button>
                    )}
                </div>
                
                <div className="keycode-name">
                    <EditableLabel
                        editOn={editOn}
                        editClassName="w-100"
                        showPencil={true}
                        placeholder={nameValue && nameValue.length > 0 ? nameValue : "Enter Key Box Name"}
                        textValue={nameValue}
                        setTextValue={val => setNameValue(val)}
                        handleLoseFocus={e => { setEditOn(false); onChangeName(nameValue); }}
                        className="form-label col-form-label"
                        labelClassName="w-100"
                        handleEditTextValue={e => setEditOn(true)}
                        showDelete={false}
                    />
                </div>
                
                <div className="keycode-value">
                    <input 
                        value={codeValue} 
                        type="text" 
                        className="form-control" 
                        placeholder="Code" 
                        onChange={e => setCodeValue(e.target.value)} 
                        onBlur={() => onChange(codeValue)}
                        maxLength="6"
                    />
                </div>
            </div>
        </div>
    );
}